import { render, staticRenderFns } from "./TrackingSheetTable.vue?vue&type=template&id=ad687c4a&"
import script from "./TrackingSheetTable.vue?vue&type=script&lang=js&"
export * from "./TrackingSheetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad687c4a')) {
      api.createRecord('ad687c4a', component.options)
    } else {
      api.reload('ad687c4a', component.options)
    }
    module.hot.accept("./TrackingSheetTable.vue?vue&type=template&id=ad687c4a&", function () {
      api.rerender('ad687c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/TrackingSheetTable.vue"
export default component.exports